import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useQuery } from '@tanstack/react-query';
import SettingConfig from '../../config/setting';

const settingConfigQueryKeys = createQueryKeys('settingConfig', {
  aspConfigSettled: null,
});

export const useASPInfo = () => {
  return useQuery({
    queryKey: settingConfigQueryKeys.aspConfigSettled.queryKey,
    queryFn: () => SettingConfig.aspInfoSettled().then((siteInfo) => siteInfo),
    staleTime: Infinity,
  });
};
